import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const EnvironmentsTableColumns: ITableColumn[] = [
  {
    labelPath: 'policyPage.policy.environments.tableColumns.environmentName',
    propertyKey: 'environmentName',
    colType: TableColumnTypeEnum.Text,
    width: 28,
    widthType: WidthType.Percentage,
    tooltipDynamicText: 'environmentDesc',
    isSortable: false,
  },
  {
    labelPath: 'policyPage.policy.environments.tableColumns.createdBy',
    propertyKey: 'createdBy',
    colType: TableColumnTypeEnum.Text,
    width: 32,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
  {
    labelPath: 'policyPage.policy.environments.tableColumns.createdAt',
    propertyKey: 'createdAt',
    colType: TableColumnTypeEnum.Date,
    width: 14,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
  {
    labelPath: 'policyPage.policy.environments.tableColumns.resources',
    propertyKey: 'resources',
    colType: TableColumnTypeEnum.Number,
    width: 13,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
  {
    labelPath: 'policyPage.policy.environments.tableColumns.status',
    propertyKey: 'statusLabel',
    colType: TableColumnTypeEnum.StatusLabel,
    width: 13,
    widthType: WidthType.Percentage,
    toCapitalize: true,
  },
];
